function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "f0acaac3-8e15-4170-a45a-e0166668d079",
  x1: 345.27105,
  y1: 402.37356,
  x2: 345.27105,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "gray",
  stopOpacity: 0.25
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.53514,
  stopColor: "gray",
  stopOpacity: 0.12
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "gray",
  stopOpacity: 0.1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "ada61551-9442-40f1-8896-9a097a6e367c",
  x1: 24.70016,
  y1: 22.44262,
  x2: 24.70016,
  y2: 10.75652,
  xlinkHref: "#f0acaac3-8e15-4170-a45a-e0166668d079"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "ee61a248-679c-4f82-b292-54d63175f0e7",
  x1: 37.97982,
  y1: 22.44262,
  x2: 37.97982,
  y2: 10.75652,
  xlinkHref: "#f0acaac3-8e15-4170-a45a-e0166668d079"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "af37cf7d-f26c-4e66-92df-c48758bfa5af",
  x1: 51.25947,
  y1: 22.44262,
  x2: 51.25947,
  y2: 10.75652,
  xlinkHref: "#f0acaac3-8e15-4170-a45a-e0166668d079"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "a974be7a-0eca-4b38-a4bb-1c3bc87b0fe2",
  x1: 352.53991,
  y1: 251.94579,
  x2: 352.53991,
  y2: 55.93254,
  xlinkHref: "#f0acaac3-8e15-4170-a45a-e0166668d079"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "b9af7108-6981-4f8a-a6a4-ecf3c3e78102",
  x1: 234.93196,
  y1: 165.2873,
  x2: 234.93196,
  y2: 144.65433,
  xlinkHref: "#f0acaac3-8e15-4170-a45a-e0166668d079"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "b84533f2-32bf-4bc5-8937-fc100537eb1d",
  x1: 286.51439,
  y1: 132.27454,
  x2: 286.51439,
  y2: 111.64157,
  xlinkHref: "#f0acaac3-8e15-4170-a45a-e0166668d079"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "ee47c5a1-3882-4af0-8161-c429bf1f8446",
  x1: 349.24621,
  y1: 103.1423,
  x2: 349.24621,
  y2: 82.50933,
  xlinkHref: "#f0acaac3-8e15-4170-a45a-e0166668d079"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "b12a05fd-a7bf-484f-a312-1b0d9c78826a",
  x1: 406.18564,
  y1: 165.2873,
  x2: 406.18564,
  y2: 144.65433,
  xlinkHref: "#f0acaac3-8e15-4170-a45a-e0166668d079"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "b151d0c6-e0ac-4f0c-bd4c-811eea96468a",
  x1: 466.02126,
  y1: 136.40114,
  x2: 466.02126,
  y2: 115.76816,
  xlinkHref: "#f0acaac3-8e15-4170-a45a-e0166668d079"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "a31da98a-37c6-4857-9382-27dedbc42410",
  x1: 352.53991,
  y1: 287.50454,
  x2: 352.53991,
  y2: 274.78403,
  xlinkHref: "#f0acaac3-8e15-4170-a45a-e0166668d079"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "b65cdeb1-be97-4a49-b541-7a630026d65b",
  x1: 352.53991,
  y1: 305.6767,
  x2: 352.53991,
  y2: 292.95619,
  xlinkHref: "#f0acaac3-8e15-4170-a45a-e0166668d079"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "b222e969-67f9-46f1-889a-787839b72ddb",
  x1: 352.53991,
  y1: 323.84886,
  x2: 352.53991,
  y2: 311.12835,
  xlinkHref: "#f0acaac3-8e15-4170-a45a-e0166668d079"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "a430500f-8a77-4964-b9ca-d23cb07dac7c",
  x1: 352.53991,
  y1: 342.02102,
  x2: 352.53991,
  y2: 329.30051,
  xlinkHref: "#f0acaac3-8e15-4170-a45a-e0166668d079"
}));

var _ref3 = /*#__PURE__*/React.createElement("title", null, "Presentation");

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  width: 690.54209,
  height: 402.37356,
  fill: "url(#f0acaac3-8e15-4170-a45a-e0166668d079)"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 9.29576,
  y: 6.63983,
  width: 673.27854,
  height: 20.58347,
  fill: "#f5f5f5"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 9.29576,
  y: 27.22329,
  width: 673.27854,
  height: 364.52655,
  fill: "#fff"
});

var _ref7 = /*#__PURE__*/React.createElement("circle", {
  cx: 24.70016,
  cy: 16.59957,
  r: 5.84305,
  fill: "url(#ada61551-9442-40f1-8896-9a097a6e367c)"
});

var _ref8 = /*#__PURE__*/React.createElement("circle", {
  cx: 37.97982,
  cy: 16.59957,
  r: 5.84305,
  fill: "url(#ee61a248-679c-4f82-b292-54d63175f0e7)"
});

var _ref9 = /*#__PURE__*/React.createElement("circle", {
  cx: 51.25947,
  cy: 16.59957,
  r: 5.84305,
  fill: "url(#af37cf7d-f26c-4e66-92df-c48758bfa5af)"
});

var _ref10 = /*#__PURE__*/React.createElement("circle", {
  cx: 24.70016,
  cy: 16.59957,
  r: 4.78068,
  fill: "#ff5252"
});

var _ref11 = /*#__PURE__*/React.createElement("circle", {
  cx: 37.84702,
  cy: 16.59957,
  r: 4.78068,
  fill: "#ff0"
});

var _ref12 = /*#__PURE__*/React.createElement("circle", {
  cx: 50.99388,
  cy: 16.59957,
  r: 4.78068,
  fill: "#69f0ae"
});

var _ref13 = /*#__PURE__*/React.createElement("rect", {
  x: 154.46336,
  y: 55.93254,
  width: 396.15309,
  height: 196.01325,
  fill: "url(#a974be7a-0eca-4b38-a4bb-1c3bc87b0fe2)"
});

var _ref14 = /*#__PURE__*/React.createElement("rect", {
  x: 158.58996,
  y: 60.05914,
  width: 387.8999,
  height: 185.69676,
  fill: "#539dfe"
});

var _ref15 = /*#__PURE__*/React.createElement("line", {
  x1: 179.22293,
  y1: 84.8187,
  x2: 179.22293,
  y2: 218.93303,
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeDasharray: "0 4"
});

var _ref16 = /*#__PURE__*/React.createElement("line", {
  x1: 178.19128,
  y1: 228.21787,
  x2: 520.69864,
  y2: 228.21787,
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref17 = /*#__PURE__*/React.createElement("line", {
  x1: 217.39393,
  y1: 92.04024,
  x2: 483.55929,
  y2: 92.04024,
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  opacity: 0.3
});

var _ref18 = /*#__PURE__*/React.createElement("line", {
  x1: 217.39393,
  y1: 122.98971,
  x2: 483.55929,
  y2: 122.98971,
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  opacity: 0.3
});

var _ref19 = /*#__PURE__*/React.createElement("line", {
  x1: 217.39393,
  y1: 153.93917,
  x2: 483.55929,
  y2: 153.93917,
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  opacity: 0.3
});

var _ref20 = /*#__PURE__*/React.createElement("line", {
  x1: 217.39393,
  y1: 184.88863,
  x2: 483.55929,
  y2: 184.88863,
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  opacity: 0.3
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M381.932,335.52261v-74.2787s-6.18989-31.98111,56.74068-30.94946c57.23284-8.12069,57.23284-31.7445,57.23284-31.7445s52.63665-5.72579,55.30639,50.27814a30.50367,30.50367,0,0,0,12.63166,23.48842c21.68706,15.294,40.51925-15.18077,49.17773-42.02206V335.52261Z",
  transform: "translate(-147 -107.30474)",
  fill: "#fff",
  opacity: 0.2
});

var _ref22 = /*#__PURE__*/React.createElement("circle", {
  cx: 286.51439,
  cy: 121.95806,
  r: 8.25319,
  fill: "#539dfe"
});

var _ref23 = /*#__PURE__*/React.createElement("circle", {
  cx: 286.51439,
  cy: 121.95806,
  r: 8.25319,
  fill: "#fff",
  opacity: 0.5
});

var _ref24 = /*#__PURE__*/React.createElement("circle", {
  cx: 234.93196,
  cy: 154.97081,
  r: 10.31649,
  fill: "url(#b9af7108-6981-4f8a-a6a4-ecf3c3e78102)"
});

var _ref25 = /*#__PURE__*/React.createElement("circle", {
  cx: 286.51439,
  cy: 121.95806,
  r: 10.31649,
  fill: "url(#b84533f2-32bf-4bc5-8937-fc100537eb1d)"
});

var _ref26 = /*#__PURE__*/React.createElement("circle", {
  cx: 349.24621,
  cy: 92.82581,
  r: 10.31649,
  fill: "url(#ee47c5a1-3882-4af0-8161-c429bf1f8446)"
});

var _ref27 = /*#__PURE__*/React.createElement("circle", {
  cx: 406.18564,
  cy: 154.97081,
  r: 10.31649,
  fill: "url(#b12a05fd-a7bf-484f-a312-1b0d9c78826a)"
});

var _ref28 = /*#__PURE__*/React.createElement("circle", {
  cx: 466.02126,
  cy: 126.08465,
  r: 10.31649,
  fill: "url(#b151d0c6-e0ac-4f0c-bd4c-811eea96468a)"
});

var _ref29 = /*#__PURE__*/React.createElement("circle", {
  cx: 234.93196,
  cy: 154.97081,
  r: 8.25319,
  fill: "#539dfe"
});

var _ref30 = /*#__PURE__*/React.createElement("circle", {
  cx: 234.93196,
  cy: 154.97081,
  r: 8.25319,
  opacity: 0.2
});

var _ref31 = /*#__PURE__*/React.createElement("circle", {
  cx: 349.24621,
  cy: 92.82581,
  r: 8.25319,
  fill: "#539dfe"
});

var _ref32 = /*#__PURE__*/React.createElement("circle", {
  cx: 349.24621,
  cy: 92.82581,
  r: 8.25319,
  opacity: 0.2
});

var _ref33 = /*#__PURE__*/React.createElement("circle", {
  cx: 406.18564,
  cy: 154.97081,
  r: 8.25319,
  fill: "#539dfe"
});

var _ref34 = /*#__PURE__*/React.createElement("circle", {
  cx: 406.18564,
  cy: 154.97081,
  r: 8.25319,
  fill: "#fff",
  opacity: 0.5
});

var _ref35 = /*#__PURE__*/React.createElement("circle", {
  cx: 466.02126,
  cy: 126.08465,
  r: 8.25319,
  fill: "#539dfe"
});

var _ref36 = /*#__PURE__*/React.createElement("circle", {
  cx: 466.02126,
  cy: 126.08465,
  r: 8.25319,
  opacity: 0.2
});

var _ref37 = /*#__PURE__*/React.createElement("rect", {
  x: 156.28058,
  y: 274.78403,
  width: 392.51866,
  height: 12.72051,
  fill: "url(#a31da98a-37c6-4857-9382-27dedbc42410)"
});

var _ref38 = /*#__PURE__*/React.createElement("rect", {
  x: 156.28058,
  y: 292.95619,
  width: 392.51866,
  height: 12.72051,
  fill: "url(#b65cdeb1-be97-4a49-b541-7a630026d65b)"
});

var _ref39 = /*#__PURE__*/React.createElement("rect", {
  x: 156.28058,
  y: 311.12835,
  width: 392.51866,
  height: 12.72051,
  fill: "url(#b222e969-67f9-46f1-889a-787839b72ddb)"
});

var _ref40 = /*#__PURE__*/React.createElement("rect", {
  x: 156.28058,
  y: 329.30051,
  width: 392.51866,
  height: 12.72051,
  fill: "url(#a430500f-8a77-4964-b9ca-d23cb07dac7c)"
});

var _ref41 = /*#__PURE__*/React.createElement("rect", {
  x: 158.09779,
  y: 276.60125,
  width: 388.88423,
  height: 9.08608,
  fill: "#e0e0e0"
});

var _ref42 = /*#__PURE__*/React.createElement("rect", {
  x: 158.09779,
  y: 294.77341,
  width: 388.88423,
  height: 9.08608,
  fill: "#e0e0e0"
});

var _ref43 = /*#__PURE__*/React.createElement("rect", {
  x: 158.09779,
  y: 312.94557,
  width: 388.88423,
  height: 9.08608,
  fill: "#e0e0e0"
});

var _ref44 = /*#__PURE__*/React.createElement("rect", {
  x: 158.09779,
  y: 331.11773,
  width: 388.88423,
  height: 9.08608,
  fill: "#e0e0e0"
});

var _ref45 = /*#__PURE__*/React.createElement("path", {
  d: "M905.15282,150.62032s1.97526,6.5842-9.21789,12.51-14.48524,28.31208-1.31684,34.89628S911.737,213.17025,905.15282,219.096s-18.43577,21.72787-2.63368,25.6784,17.77735,11.85156,13.1684,15.14366,10.53473-5.92578,10.53473-5.92578,2.63368,15.80209,16.46051,11.85157,52.67362-79.01044,32.921-89.54517S905.15282,150.62032,905.15282,150.62032Z",
  transform: "translate(-147 -107.30474)",
  fill: "#2f2e41"
});

var _ref46 = /*#__PURE__*/React.createElement("polygon", {
  points: "809.169 601.511 804.889 641.464 823.438 652.879 840.561 650.025 832 601.511 809.169 601.511",
  fill: "#9f616a"
});

var _ref47 = /*#__PURE__*/React.createElement("circle", {
  cx: 794.90056,
  cy: 82.12201,
  r: 39.95301,
  fill: "#9f616a"
});

var _ref48 = /*#__PURE__*/React.createElement("path", {
  d: "M928.34508,208.68981s-3.56724,60.643-7.84792,60.643,49.94126-2.85378,49.94126-2.85378-22.83029-39.953-11.41514-52.795S928.34508,208.68981,928.34508,208.68981Z",
  transform: "translate(-147 -107.30474)",
  fill: "#9f616a"
});

var _ref49 = /*#__PURE__*/React.createElement("polygon", {
  points: "840.561 421.723 822.012 493.067 836.28 614.353 803.462 611.499 790.62 421.723 840.561 421.723",
  fill: "#2f2e41"
});

var _ref50 = /*#__PURE__*/React.createElement("polygon", {
  points: "840.561 421.723 822.012 493.067 836.28 614.353 803.462 611.499 790.62 421.723 840.561 421.723",
  opacity: 0.2
});

var _ref51 = /*#__PURE__*/React.createElement("path", {
  d: "M959.02328,741.63439s-1.42689-8.56136-15.69583,0-74.19844,35.67233-42.80679,41.3799,95.60184-7.13446,95.60184-11.41514,1.42689-31.39165-4.28068-28.53786S967.58464,764.46468,959.02328,741.63439Z",
  transform: "translate(-147 -107.30474)",
  fill: "#2f2e41"
});

var _ref52 = /*#__PURE__*/React.createElement("path", {
  d: "M977.57289,731.64614s22.83029,35.67233,24.25718,45.66058,22.83029-22.83029,22.83029-22.83029l-19.9765-37.09922Z",
  transform: "translate(-147 -107.30474)",
  fill: "#9f616a"
});

var _ref53 = /*#__PURE__*/React.createElement("path", {
  d: "M901.94755,534.73489l25.68408,85.61359s45.66058,121.28591,48.51437,119.859,37.09922-9.98825,38.52611-14.26893-42.80679-119.859-42.80679-119.859l-5.70758-74.19845Z",
  transform: "translate(-147 -107.30474)",
  fill: "#2f2e41"
});

var _ref54 = /*#__PURE__*/React.createElement("path", {
  d: "M1028.941,748.76886a18.732,18.732,0,0,0-18.54961,11.41514c-5.70757,12.842-12.842,14.26894-14.26893,15.69583s4.28068,31.39165,0,34.24543-8.56136,32.81855,5.70757,32.81855,37.09922-15.69583,35.67233-18.54961-1.42689-22.83029,2.85379-31.39165,11.41514-22.83029,0-31.39165S1028.941,748.76886,1028.941,748.76886Z",
  transform: "translate(-147 -107.30474)",
  fill: "#2f2e41"
});

var _ref55 = /*#__PURE__*/React.createElement("path", {
  d: "M893.38619,402.03383l-2.85378,25.68407s-21.4034,21.4034-28.53786,47.08748-65.63709,68.49087-48.51437,74.19844,37.09922,8.56136,87.04048,0S1028.941,558.99207,1028.941,511.9046c0,0,9.98825-12.842,17.12272,5.70757a372.95,372.95,0,0,0,17.12272,37.09922s17.12272-29.96475,11.41514-42.80679,0-11.41515-7.13446-25.68408-42.8068-67.064-57.07573-69.91776-41.3799-39.953-39.953-44.23369S893.38619,402.03383,893.38619,402.03383Z",
  transform: "translate(-147 -107.30474)",
  fill: "#539dfe"
});

var _ref56 = /*#__PURE__*/React.createElement("path", {
  d: "M970.43842,242.2218s-58.50261,12.842-61.3564,21.40339c-1.60526,4.81577-9.07972,13.69483-15.31263,20.54225a80.19812,80.19812,0,0,0-20.13937,40.865c-1.488,9.10321,4.76806,17.28861,7.62758,27.77353,8.56136,31.39165,14.98238,23.54374,6.421,46.374s42.8068,31.39165,62.7833,21.4034,42.09335-69.20432,42.09335-76.33879,19.26306-87.75392,3.56723-93.4615S970.43842,242.2218,970.43842,242.2218Z",
  transform: "translate(-147 -107.30474)",
  fill: "#575a88"
});

var _ref57 = /*#__PURE__*/React.createElement("path", {
  d: "M889.10552,310.71267,871.9828,386.338l-56.36228,24.97063s-42.8068-9.98825-44.23369,5.70757c-.93156,10.24722,48.51437,14.26894,48.51437,14.26894L901.94755,399.18l18.54961-69.91776Z",
  transform: "translate(-147 -107.30474)",
  fill: "#9f616a"
});

var _ref58 = /*#__PURE__*/React.createElement("path", {
  d: "M909.082,282.1748s-35.67233,21.4034-27.111,32.81855,29.96476,29.96475,35.67233,29.96475,9.98825-34.24543,9.98825-44.23369S909.082,282.1748,909.082,282.1748Z",
  transform: "translate(-147 -107.30474)",
  fill: "#575a88"
});

var _ref59 = /*#__PURE__*/React.createElement("path", {
  d: "M944.775,137.54579s2.18819,7.294-10.21158,13.85856-16.04675,31.36412-1.45879,38.6581,18.96435,16.77615,11.67037,23.34073-20.42315,24.07014-2.9176,28.44653,19.69375,13.12916,14.588,16.77615,11.67036-6.56458,11.67036-6.56458,2.9176,17.50555,18.235,13.12917,30.60033-83.92894,13.52581-104.41835C984.00017,141.72057,944.775,137.54579,944.775,137.54579Z",
  transform: "translate(-147 -107.30474)",
  fill: "#2f2e41"
});

var _ref60 = /*#__PURE__*/React.createElement("path", {
  d: "M940.11565,130.038c.00333-10.68606,31.97356-3.00762,45.6807,11.91249,9.49186,10.332,23.909,25.8761,11.82788,36.83315s20.70807,25.32061,29.50187,29.6755,26.15658,17.67229,10.47926,26.60643-15.42456,17.95275-9.52456,20.08807-13.00812-3.17493-13.00812-3.17493,1.91028,17.64391-14.01979,17.55944-61.63218-87.6315-50.71431-111.96574C960.49026,134.94584,940.11565,130.038,940.11565,130.038Z",
  transform: "translate(-147 -107.30474)",
  fill: "#2f2e41"
});

var _ref61 = /*#__PURE__*/React.createElement("path", {
  d: "M947.04049,127.69616c-42.75256-2.57441-47.04328,29.60705-47.04328,29.60705.29555,18.62345,29.87039,9.54908,38.08458,12.32535,9.91-7.1289,29.01209-20.6176,42.67337-30.24379A64.61221,64.61221,0,0,0,947.04049,127.69616Z",
  transform: "translate(-147 -107.30474)",
  fill: "#2f2e41"
});

var SvgIntroduction = function SvgIntroduction(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "beee3da8-7262-4ec9-9c48-b995a89b9850",
    "data-name": "Layer 1",
    viewBox: "0 0 928.76643 735.63906",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIntroduction, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/introduction.e68358b4.svg";
export { ForwardRef as ReactComponent };